// Server-injected per request (config/env.config.js writes `window._env_` into
// <head> before the bundle runs), so the same build serves every environment.
// Absent under `npm start` and in tests — every read has to tolerate that.
declare global {
  interface Window {
    _env_?: Record<string, string | undefined>
  }
}

export const getRuntimeEnv = (name: string): string | null => {
  if (typeof window === 'undefined') {
    return null
  }
  const value = window._env_?.[name]
  return value && value.trim() ? value.trim() : null
}
